import React, { useState } from 'react';
import { Modal, IconButton, Box } from '@mui/material';
import Close from '@mui/icons-material/Close';

import {
  GuideModalContainer,
  GuideModalHeader,
  GuideModalHeaderTitle,
  GuideModalBody,
  GuideSection,
  GuideSectionLabel,
  GuideText,
  GuideDivider,
} from '../../../lesson/groupLesson/GroupLessonStyled';

const TABS = [
  { key: 'overview', label: '일일권/체험권이란?' },
  { key: 'fields', label: '등록 항목' },
  { key: 'usage', label: '유효기간·차감시점' },
  { key: 'refund', label: '환불·발급·주의사항' },
];

const OverviewGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>🎁 일일권/체험권이란?</GuideSectionLabel>
      <GuideText>
        수강권·이용권과는 <strong>완전히 별개의 상품군</strong>입니다.<br />
        "체험권"이라는 하나의 상품군 안에 <strong>레슨형</strong>(개인레슨/그룹레슨 체험)과 <strong>자유이용형</strong>(자유이용 일일권)이 함께 있어서, 현장에서 "체험권"과 "일일권"이라는 용어가 섞여 쓰입니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🔀 레슨형 vs 자유이용형</GuideSectionLabel>
      <GuideText>
        • <strong>자유이용형</strong>을 선택하면 이용기간 <strong>1일</strong>, 이용횟수 <strong>1회</strong>로 자동 고정되고, 요일·시간대·중지권 등 세부 설정 항목은 <strong>입력해도 적용되지 않습니다(무시됨).</strong><br />
        • <strong>레슨형</strong>(개인/그룹)을 선택하면 <strong>횟수제로 고정</strong>됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🆓 무료/유료 구분</GuideSectionLabel>
      <GuideText>
        별도의 "무료 여부" 항목은 없습니다. <strong>최종 결제금액이 0원이면 무료 체험권</strong>, 0원보다 크면 유료 일일권입니다.
      </GuideText>
    </GuideSection>
  </>
);

const FieldsGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>➕ 등록 시 입력 항목</GuideSectionLabel>
      <GuideText>
        • 상품명, 판매지점/이용지점, 종목(복수), 입장 가능 출입문<br />
        • 가격(정상가/할인/최종가) — <strong>0원 설정 시 무료</strong><br />
        • 판매기간, 할인기간<br />
        • 1인당 최대 구매(발급)횟수, 전체 재고수량
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⏱️ 이용설정</GuideSectionLabel>
      <GuideText>
        • 이용기간(레슨형만 직접 설정 가능), 이용횟수<br />
        • 이용구분 — 레슨형은 횟수제 고정 / 자유이용형은 기간제(1일) 고정<br />
        • <strong>레슨형에만 적용</strong>: 일일·주간 이용제한, 중지권, 취소·예약 가능 횟수, 요일·시간대 제한, 수업 기본시간, 담당 트레이너, 커리큘럼
      </GuideText>
    </GuideSection>
  </>
);

const UsageGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>📅 유효기간</GuideSectionLabel>
      <GuideText>
        • 결제(또는 이용 시작) 시점을 시작일로, 이용기간만큼 만료일이 계산됩니다.<br />
        • 매일 자동으로 만료일이 지난 건은 <strong>"사용불가(비활성)"</strong>로 전환됩니다(별도의 "만료" 상태는 없습니다).
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>➖ 차감 시점</GuideSectionLabel>
      <GuideText>
        • 레슨형은 <strong style={{ color: '#EE753A' }}>"예약한 순간"이 아니라 "출석/결석이 확정된 순간"</strong>에 차감됩니다.<br />
        • 단, 예약만 잡혀 있어도 그 예약 건수까지 포함해서 신규 예약 가능 여부를 계산합니다. 그래서 <strong>잔여횟수가 남아있어 보여도 추가 예약이 막힐 수 있습니다.</strong><br />
        • 자유이용형은 키오스크 등에서 1회 사용하면 즉시 소진되어 "사용완료" 상태가 됩니다.
      </GuideText>
    </GuideSection>
  </>
);

const RefundGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>💸 환불</GuideSectionLabel>
      <GuideText>
        • 결제수단이 <strong>"수기결제/무통장"</strong>인 건만 관리자 화면에서 직접 환불할 수 있습니다.<br />
        • <strong style={{ color: '#EE753A' }}>카드 등 PG 결제건은 관리자 화면 환불 버튼이 동작하지 않으며,</strong> PG사 절차로 처리해야 합니다.<br />
        • 환불 가능 대상: 결제완료 + 사용중 상태 중 <strong>가장 먼저 시작된 건 1개</strong>만 가능합니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>📮 발급 절차</GuideSectionLabel>
      <GuideText>
        • 별도의 "관리자 무료 증정" 버튼은 없습니다. 회원이 체험권을 갖게 되는 경로는 <strong>(1) 모바일 앱에서 직접 구매, (2) 계약(가입) 체결 시 자동 생성</strong> 두 가지뿐입니다.<br />
        • 이미 발급된 건의 시작일/만료일/횟수는 회원 상세 화면에서 사후 수정 가능하며, 수정 이력이 남습니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⚠️ 주의사항</GuideSectionLabel>
      <GuideText>
        • 1인당 구매 제한은 <strong>"사용중 + 비활성" 상태를 모두 합산</strong>해서 카운트합니다. 다 쓰고 비활성된 체험권도 재구매 제한에 포함됩니다. 단, <strong>환불받은 건은 제외</strong>되어 다시 구매할 수 있습니다.<br />
        • 같은 회원이 그룹/개인 체험권을 동시에 여러 개 보유하는 것도 현재는 가능합니다(과거엔 동일 지점·동일 종목 중복 보유가 제한되었으나 현재는 폐지됨).<br />
        • "판매 ON/OFF" 스위치는 <strong>상품 자체의 판매 상태</strong>이고, 회원 개개인이 보유한 체험권의 사용가능/불가 상태와는 <strong>별개 개념</strong>이므로 혼동하지 않도록 주의하세요.
      </GuideText>
    </GuideSection>
  </>
);

const TAB_CONTENT = {
  overview: OverviewGuide,
  fields: FieldsGuide,
  usage: UsageGuide,
  refund: RefundGuide,
};

const TrialGuideModal = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const TabContent = TAB_CONTENT[activeTab];

  return (
    <Modal open={open} onClose={onClose} disableScrollLock>
      <GuideModalContainer>
        <GuideModalHeader>
          <GuideModalHeaderTitle>일일권 가이드</GuideModalHeaderTitle>
          <IconButton onClick={onClose} sx={{ color: '#fff', p: '4px' }}>
            <Close />
          </IconButton>
        </GuideModalHeader>

        {/* 탭 */}
        <Box sx={{
          display: 'flex', borderBottom: '1px solid #e0e0e0', flexShrink: 0, backgroundColor: '#fafafa',
        }}>
          {TABS.map(tab => (
            <Box
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              sx={{
                flex: 1, textAlign: 'center', padding: '12px 0', cursor: 'pointer',
                fontSize: '13px', fontWeight: activeTab === tab.key ? 700 : 500,
                fontFamily: 'Pretendard, sans-serif',
                color: activeTab === tab.key ? '#4AB3BC' : '#888',
                borderBottom: activeTab === tab.key ? '2px solid #4AB3BC' : '2px solid transparent',
                transition: 'all 0.15s ease',
                '&:hover': { color: '#4AB3BC', backgroundColor: '#f0f8f8' },
              }}
            >
              {tab.label}
            </Box>
          ))}
        </Box>

        <GuideModalBody>
          <TabContent />
        </GuideModalBody>
      </GuideModalContainer>
    </Modal>
  );
};

export default TrialGuideModal;
